import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel';

const BASE = BaseModel.getApiBasePath() + '/api/v1/core/cities';

export default new class CityModel {

    get(id) {
        return new Promise((resolve, reject) => {
            this.getAll()
                .then((data) => {
                    resolve(_.find(data, { id: id }));
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getAll(force = false) {
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    Promise.all([ParkinglocationModel.getAll(true)])
                        .then((r) => {
                            let parkingLocations = r[0];
                            let resp = [];
                            response.data.map(async (city, idx) => {
                                let data = [];
                                city.locations.map(async (locationId, idx) => {
                                    let tLocation = _.find(parkingLocations, { id: locationId });
                                    if (!tLocation || tLocation === undefined) {
                                        data.push({ id: locationId, parkingLocationName: "Neznámá lokalita" })
                                    } else {
                                        data.push({ id: locationId, parkingLocationName: tLocation.Code + ' - ' + tLocation.Name })
                                    }
                                });
                                city.locationsNames = data;
                                resp.push(Object.assign({}, city, { key: city.id }));
                            });
                            resolve(resp);
                        })
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getCityNames(force = false) {
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken(),
                    filter: {
                        order: "code ASC"
                    }
                }
            })
                .then((response) => {
                    let resp = [];
                    resp.push({ id: '*', code: '*', name: 'všechna města', key: '*' })
                    response.data.map(async (city, idx) => {
                        resp.push(Object.assign({}, city, { key: city.id }));
                    });
                    resolve(resp);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    create(data) {
        return new Promise((resolve, reject) => {
            axios.post(BASE, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    patch(id, data) {
        return new Promise((resolve, reject) => {
            axios.patch(BASE + '/' + id, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            axios.delete(BASE + '/' + id, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/CityModel.js